import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=a112568e&scoped=true&"
import script from "./FeedbackCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&id=a112568e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a112568e",
  null
  
)

export default component.exports